import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import TripTimeArrow from '../../assets/images/ic-route-arrow-light.png';
import TripTimeArrowMegabus from '../../assets/images/megabus/ic-route-arrow-light.svg';

import { getTime } from '../../helpers/Helpers';

import infoIcon from '../../assets/images/information-icon-blue.svg';

import { THEME } from '../../configs/global';
import DublinTowardImg from '../../assets/images/dublin-express/arrow-results.svg';
import MegabusTowardImg from '../../assets/images/megabus/arrow-results.svg';
import NXbusTowardImg from '../../assets/images/nxbus/arrow-results.svg';

import { showDueTimeStatus } from './ServiceMap';

const getServiceStatus = (service) => {
  if (!THEME.REALTIME)
  return <span className="orange">{'Info \u00BB'}</span>;
  const from_stop = service.from_stop_tracking ? service.from_stop_tracking : service.from_stop ? service.from_stop : service.stop;
  if (!service.tracking)
    return <span className="gray">{'Unknown \u00BB'}</span>;
  else if (service.tracking && service.tracking.is_future_trip)
    return <span className="orange">{'Scheduled \u00BB'}</span>;
  else if (service.tracking && service.tracking.is_completed)
    return <span>{'Arrived \u00BB'}</span>;
  else if (service.tracking && service.tracking.is_cancelled)
    return <span className="red">{`${THEME.CANCELLED_TEXT ? THEME.CANCELLED_TEXT : 'Cancelled'} \u00BB`}</span>;
  else if (service.tracking && (service.tracking.has_no_vehicle || service.tracking.has_no_gps))
    return <span className="gray">{'Not trackable \u00BB'}</span>;
  else if (from_stop && !service.active_vehicle && !from_stop.live_arrival_time_unix && !from_stop.estimated_arrival_time_unix)
    return <span className="orange">{'Scheduled \u00BB'}</span>;
  else
    return <span className="green">{'Track \u00BB'}</span>;
};

const getTimeStatus = (service) => {
  const from_stop = service.from_stop ? service.from_stop : service.stop;
  /*if (!service.is_future_trip) {
      return service.history.late ? (
        <span className="service-time--red">{`Dep ${getTime(
          service.history.depart
        )}`}</span>
      ) : (
        `Dep ${getTime(service.history.depart)}`
      );
    return '';
  }*/
  if (service.tracking && service.tracking.is_cancelled) {
    return '';
  }
  if (service.tracking && (service.tracking.has_no_vehicle || service.tracking.has_no_gps)) {
    return '';
  }

  if (!THEME.REALTIME)
    return '';
  if (from_stop && from_stop.estimated_departure_time_formatted_local && service.tracking.current_delay_seconds > THEME.LATE_OFFSET) {
    return (
      <span className="service-time--red">{`Exp ${getTime(
        from_stop.estimated_departure_time_formatted_local
      )}`}</span>
    );
  } else if (from_stop && !service.tracking.is_arrived && from_stop.estimated_departure_time_formatted_local) {
    return (`Exp ${getTime(from_stop.estimated_departure_time_formatted_local)}`)
  }

  if (from_stop && from_stop.live_departure_time_unix) {
    return (
      from_stop.live_departure_time_unix > from_stop.scheduled_departure_time_unix + THEME.LATE_OFFSET ? (
        <span className="service-time--red">{`Dep ${getTime(
          from_stop.live_departure_time_formatted_local
        )}`}</span>
      ) : (
        `Dep ${getTime(from_stop.live_departure_time_formatted_local)}`
      )
    );
  }

  if (from_stop && from_stop.estimated_departure_time_formatted_local && service.tracking.current_delay_seconds > THEME.LATE_OFFSET) {
    return (
      <span className="service-time--red">{`Exp ${getTime(
        from_stop.estimated_departure_time_formatted_local
      )}`}</span>
    );
  } else if (from_stop && from_stop.estimated_departure_time_formatted_local) {
    return (`Exp ${getTime(from_stop.estimated_departure_time_formatted_local)}`)
  }

  if (service.tracking && (service.tracking.has_no_vehicle || service.tracking.has_no_gps))
    return 'Not trackable';

  return 'On time';
};

const getArrowIcon = (name) => {
  switch (name) {
    case 'Dublin-Express':
      return DublinTowardImg;
    case 'Megabus':
      return MegabusTowardImg;
    case 'NX-Bus':
      return NXbusTowardImg;

    default:
      return null;
  }
};

export const Service = ({
  service,
  showServiceDetails,
  toggleCancelledInfoModal,
  searchByTicket,
  showChange,
  future,
}) => (
  <Fragment>
    <div
      className={`results-service ${
        service.tracking ? '' : 'disabled'
      }`}
      onClick={service.tracking ? showServiceDetails(service) : 'return false'}
    >
      <div className="results-service__top">
        <div className="results-service__route">{service.trip_short_name ? service.trip_short_name : service.trip.route_id}</div>
        <div className="results-service__path">
          <span className="toward">towards</span>
          {getArrowIcon(THEME.NAME) ? (
            <img src={getArrowIcon(THEME.NAME)} alt="toward" />
          ) : (
            ''
          )}
          <br />
          {service.to_stop && service.to_stop.public_facing_name ? service.to_stop.public_facing_name : service.trip.arrival_location_name}
        </div>
        
        {!THEME.HIGH_FREQUENCY_SERVICES.includes(service.trip.route_id) && !THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(service.trip.route_id[0]) && !service.ticket_leg_metadata ? 
          <div className="results-service__time">
            <span>{getTime(service.ticket_leg_metadata ? service.ticket_leg_metadata.departure_time_formatted_local : service.from_stop ? service.from_stop.scheduled_departure_time_formatted_local : service.stop ? service.stop.scheduled_departure_time_formatted_local : service.trip.departure_time_formatted_local)}</span>
            {!future && getTimeStatus(service)}
          </div> : 
          <div className="results-service__time">
            <span>{showDueTimeStatus(service.from_stop)}</span>
          </div>
        }
      </div>
      <div className="results-service__btm">
        <div className="results-service__info"></div>
        <div className="results-service__duration">
          {!THEME.HIGH_FREQUENCY_SERVICES.includes(service.trip.route_id) && !THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(service.trip.route_id[0]) && !service.ticket_leg_metadata ?
          !future && service.tracking && (service.tracking.is_cancelled || service.tracking.has_no_vehicle) ?
          <Fragment>
            {THEME.CANCELLED_TEXT ? <span className="spanhref" onClick={toggleCancelledInfoModal()}>{THEME.CANCELLED_TEXT}{THEME.CANCELLED_INFO && <img src={infoIcon} height="80%" alt="high frequency route info" />}</span>
            : <span className="gray">{'Cancelled'}</span>}
          </Fragment> :
          <Fragment>
            <span>{getTime(service.ticket_leg_metadata ? service.ticket_leg_metadata.departure_time_formatted_local : service.from_stop ? service.from_stop.scheduled_departure_time_formatted_local : service.stop ? service.stop.scheduled_departure_time_formatted_local : service.trip.departure_time_formatted_local)}</span>
            <img
              src={
                THEME.NAME === 'Megabus' || THEME.NAME === 'NX-Bus'
                  ? TripTimeArrowMegabus
                  : TripTimeArrow
              }
              alt="Trip arrow"
            />
            <span>{getTime(service.ticket_leg_metadata ? service.ticket_leg_metadata.arrival_time_formatted_local : service.to_stop ? service.to_stop.scheduled_arrival_time_formatted_local : service.trip.arrival_time_formatted_local)}</span>
          </Fragment> :
          <Fragment>
          {!future && service.tracking && (service.tracking.is_cancelled || service.tracking.has_no_vehicle) ?
          <Fragment>
            {THEME.CANCELLED_TEXT ? <span className="spanhref" onClick={toggleCancelledInfoModal()}>{THEME.CANCELLED_TEXT}<img src={infoIcon} height="80%" alt="high frequency route info" /></span>
            : <span className="gray">{'Cancelled'}</span>}
          </Fragment> :
          <Fragment><span>{`${service.from_stop && service.from_stop.live_departure_time_formatted_local ? 'Departed' : 'Expected arrival'} ${getTime(service.ticket_leg_metadata ? service.ticket_leg_metadata.arrival_time_formatted_local : service.from_stop ? service.from_stop.live_departure_time_formatted_local ? service.from_stop.live_departure_time_formatted_local : service.from_stop.estimated_arrival_time_formatted_local ? service.from_stop.estimated_arrival_time_formatted_local : service.from_stop.scheduled_arrival_time_formatted_local : service.trip.arrival_time_formatted_local)}`}</span></Fragment>}
        </Fragment>
        }
        </div>
        <div className="results-service__tracking">
          {service.tracking && (service.tracking.is_cancelled || service.tracking.has_no_vehicle) ? <span className="orange">{'Scheduled \u00BB'}</span> : getServiceStatus(service)}
        </div>
      </div>
    </div>
    {!!searchByTicket && showChange && (
      <div className="change-coach">
        <span className="icon"></span>Change coach
        {THEME.NAME === 'Megabus' ? ` (departing ${service.from_stop.scheduled_departure_time_formatted_local})` : ''}
      </div>
    )}
  </Fragment>
);

Service.propTypes = {
  service: PropTypes.object.isRequired,
  showServiceDetails: PropTypes.func.isRequired,
  searchByTicket: PropTypes.bool,
};

export default Service;



// WEBPACK FOOTER //
// ./src/containers/service-list/Service.js